import { Elements } from '@stripe/react-stripe-js';
import { getStripePromise } from 'app/http/stripeConfig';
import { useMemo } from 'react';

export const StripeWrapper = ({ children }: { children: React.ReactNode }) => {
  const stripePromise = useMemo(() => getStripePromise(), []);
  return <Elements stripe={stripePromise}>{children}</Elements>;
};
